export default __webpack_public_path__ + "static/media/vaishnavi.e291b31c.jpeg";